            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
      <b-row style="width:100%">
        <b-col sm="12">
          <b-row  class="row-inputs">
            <p>Aquí inactivara <span style="font-weight:700"></span> permanentemente del sistema.</p>             
          </b-row>
        </b-col>
      </b-row>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px">
        <b-row style="padding-top: 10px;">
          <b-col class="text-right">             
              <b-button  @click="save(false)" 
                variant="success" 
                size="sm" 
                class="ml-2" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
              >Inactivar
              </b-button>
          </b-col>
        </b-row> 
      </footer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
export default 
{
  name: 'swmodalasesores',
  components: {
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    }
  },
  computed: {    
    ...mapState({
    })
  },
  async created()
  {
    await this.updateDataForm({data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]]})
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
    await this.resetDataForm()
  },
  methods: {
    async save(emit)
    {
      
      this.$emit('save', {save: emit, ftn: 'inactivarFtn'})
    },
  }
}
</script>
<style>
</style>